import Vue from 'vue';
import Tab from '../general/tab';
import axios from 'axios';
import * as FormHelpers from '../../helpers/formhelpers';

export default Vue.component('backofficetab', {
    extends: Tab,
    data: function(){
        return {
            axe: axios.create({
                baseURL: '/mywecycle/servicepoint'
            }),
            form: null
        }
    },
    methods:{
        loadContent(){
            this.servicePointId = this.$parent.servicePointId;
            this.axe.get('/servicepointbackofficetab', { params: { servicePointId: this.servicePointId }})
                .then((response) => { return this.renderTabContent(response.data); })
                .then((tabElem) => { this.initializeContent(tabElem) })
                .catch((error) => { console.log('Error retrieving tab content : ' + error); });
        },
        initializeContent(tabElem){
            const _self = this;
            this.initializeForm(tabElem);
            One.helpers(['core-bootstrap-custom-file-input', 'select2']);
            
            tabElem.find('input[name="operations--servicepoint__municipalityservicepoint"]').on('change', function () {
                _self.$root.$emit("destroyDetailTab"); // Emit event to destroy detail tab and force re-render
            });

            MyStichtingOpen.ServicePoints.initSsdsUpload();
            MyStichtingOpen.ServicePoints.municipalityServicePoint();
        },
        initializeForm(tabElem){
            this.form = tabElem.find('.js-backoffice-servicepoint');
        },
        saveTab(){
            let formData = FormHelpers.getFormData(this.form);
            this.axe.post('/servicepointbackoffice', formData)
            .then((response) => { 
                let ssdsUpload = response.data.SSDSUploadHtml;
                if (ssdsUpload != null) {
                    var $ssdsUploadContainer = $('div[data-ssds-upload]');
                    $ssdsUploadContainer.html(ssdsUpload);
                    MyStichtingOpen.ServicePoints.initSsdsUpload();
                    One.helpers('core-bootstrap-tooltip');
                }

                return true; 
            })
            .then((submitedWithSuccess) => {
                if(submitedWithSuccess){ this.$emit('submit', true); }
            })
            .catch((error) => {
                console.log('Error saving detail tab : ' + error);
                this.$emit('submiterror');
            });      
        }
    },
    mounted(){

    },
    created() {
        this.loadContent();
    }
});